import { N800 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { h5Css } from '@atlassian/amkt-common';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';

import { LargeAkButton } from '../../../../../app/components/common/styledComponents';

const TextContainer = styled.div`
  color: ${N800};
`;

const HeadingDiv = styled.div`
  ${h5Css}
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 1px;
  line-height: 20px;
  margin-bottom: 0;
  text-transform: uppercase;
`;

const TextP = styled.p`
  font-size: 14px;
  line-height: 18px;
  margin: ${token('space.150', '12px')} 0;
`;

const SubscribeButtonDiv = styled.div`
  width: 156px;
`;

const ContainerDiv = styled.div`
  margin-bottom: 25px;
`;

export default class SubscribeToMailingList extends React.PureComponent {
  static propTypes = {
    onSubscribeClicked: PropTypes.func.isRequired,
  };

  render() {
    return (
      <ContainerDiv>
        <TextContainer>
          <HeadingDiv>Email updates</HeadingDiv>
          <TextP>Get latest app recommendations by email.</TextP>
        </TextContainer>

        <SubscribeButtonDiv>
          <LargeAkButton
            appearance="primary"
            // @ts-expect-error [MC-2850] - TS2339 - Property 'onSubscribeClicked' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
            onClick={this.props.onSubscribeClicked}
            shouldFitContainer={true}
          >
            Subscribe
          </LargeAkButton>
        </SubscribeButtonDiv>
      </ContainerDiv>
    );
  }
}
